import { type IPlayerState, type IPlayerStateManager } from '../types/player';

export class PlayerStateManager implements IPlayerStateManager {
  private state: IPlayerState = {
    volumeLevel: 1,
  };

  constructor(initialState: IPlayerState = {}) {
    this.state = { ...this.state, ...initialState };
  }

  public setState(state: Partial<IPlayerState>): void {
    this.state = { ...this.state, ...state };
  }

  public getState(): IPlayerState {
    return this.state;
  }
}
